<template lang="pug">
span.y-chip(:class="[chipClass, textSize, color, outlinedClass]")
  slot(name="prepend")
  span {{ label }}
  slot
  slot(name="append")
  
</template>

<script>
export default {
  name: 'YChip',
  props: {
    label: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'normal'
    },
    size: {
      type: String,
      default: 'sm'
    },
    outlined: {
      type: Boolean,
      default: false
    },
    chipClass: {
      type: String,
      default: null
    }
  },
  computed: {
    textSize () {
      switch (this.size) {
        case 'xs':
          return 'text-xs'
        case 'sm':
          return 'text-sm'
        case 'md':
          return 'text-md'
        default:
          return 'text-sm'
      }
    },
    outlinedClass () {
      return this.outlined ? 'outlined' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.y-chip {
  border-radius: 6px;
  display: inline-flex;
  position: relative;
  align-items: center;
  vertical-align: middle;
  padding: 2px 5px;
}
.height-24 {
  height: 24px;
}
.height-18 {
  height: 18px;
}
.normal {
  background: #F9FAFB !important;
  color: #333333 !important;
}
.red {
  background: #FFEBEB !important;
  color: #B52222 !important;
}
.green {
  background: #EEFCE9 !important;
  color: #1A7935 !important;
}
.orange {
  background: #FFF7D9 !important;
  color: #CA6C16 !important;
}
.grey {
  background: #848484 !important;
  color: #FFFFFF !important;
}
.blue {
  background: #F0F8FF !important;
  color: #3570CA !important;
}
.outlined {
  border: 1px solid #EEEEEE !important;
}
</style>